"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useContract = void 0;
var react_1 = require("react");
var contracts_1 = require("@ethersproject/contracts");
var constants_1 = require("@ethersproject/constants");
var address_1 = require("@ethersproject/address");
var useWeb3_1 = require("./useWeb3");
var error_1 = require("../utils/error");
var getContract = function (address, ABI, signerOrProvider) {
    if (!(0, address_1.isAddress)(address) || address === constants_1.AddressZero) {
        throw new error_1.InvalidAddressError(address);
    }
    return new contracts_1.Contract(address, ABI, signerOrProvider);
};
var useContract = function (ABI, useSigner) {
    var _a = (0, useWeb3_1.useActiveWeb3)(), account = _a.account, library = _a.library;
    return (0, react_1.useCallback)(function (address) {
        if (!library)
            throw new error_1.LibraryNotExistError();
        if (!useSigner)
            return getContract(address, ABI, library);
        if (!account)
            throw new error_1.WalletNotConnectedError();
        var signer = library
            .getSigner(account)
            .connectUnchecked();
        return getContract(address, ABI, signer);
    }, [account, library, ABI, useSigner]);
};
exports.useContract = useContract;
exports.default = exports.useContract;
